var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_BankReceiptRecord"),
                    name: "bankSlipRegister"
                  }
                },
                [
                  _c("bank-slip-register", {
                    attrs: {
                      "tab-name": "bankSlipRegister",
                      "tab-title": _vm.$t("CargoMsg.Cargo_BankReceiptRecord")
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ClaimBankReceipt"),
                    name: "bankSlipRollBack"
                  }
                },
                [
                  _c("bank-slip-write-off", {
                    attrs: {
                      "tab-name": "bankSlipWriteOff",
                      "tab-title": _vm.$t("CargoMsg.Cargo_ClaimBankReceipt")
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_RevokeClaim"),
                    name: "bankSlipWriteOff"
                  }
                },
                [
                  _c("bank-slip-roll-back", {
                    attrs: {
                      "tab-name": "bankSlipRollBack",
                      "tab-title": _vm.$t("CargoMsg.Cargo_RevokeClaim")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }